import * as RadixDropdown from '@radix-ui/react-dropdown-menu';
import {
  StyledCheckboxItem,
  StyledItem,
  StyledItemIndicator,
  StyledSeparator,
  StyledSubContent,
  StyledSubTrigger,
} from './dropdown.styled';
import { Content } from './overrides/content';

export const Dropdown = {
  ...RadixDropdown,
  Content,
  SubTrigger: StyledSubTrigger,
  SubContent: StyledSubContent,
  CheckboxItem: StyledCheckboxItem,
  ItemIndicator: StyledItemIndicator,
  Item: StyledItem,
  Separator: StyledSeparator,
};
